export const environment = {
  APP_ENV: 'PROD',
  production: true,
  env: 'prod',
  SITE_DETAILS_API: '/site/api/v2/details/public',
  ASSET_DETAILS_API : 'https://marketingassets.marketwise.com',
  OFFER_EXPIRY_PAGE: 'https://marketingassets.marketwise.com/test/templates/OfferEndedPage/offer_ended_page.html',
  CREATE_ELETTER_API: '/leads/api/v1/eletter/public',
  CREATE_HOTLIST_API: '/leads/api/v1/hotlist/public',
  CREATE_COI_API: '/leads/api/v1/customer-settings/coi/public',
  DOUBLE_OPTIN_SEND_EMAIL_API: '/leads/api/v1/customer-settings/doi/public',
  EVENTSTREAM_API: '/snowflake/api/v1/generic/public',
  DDG_LOGGER_CLIENT: 'pub2a1eacb4678c8ac666513170783471aa',
  SNOW_PLOW_COLLECTOR_URL: 'com-marketwise-prod1.collector.snplow.net',
  AWS_WAF_CAPTCHA_API: '/site/api/v2/waf/captcha/public'
};
